import { publish } from 'pubsub-js';

import { Text } from 'components/blueprint';

import { ActionLabelPill } from 'components/Reply/ActionPillWrapper';

export const EVENT_CHATBOT_FAQ = 'EVENT_CHATBOT_FAQ';

export const ChatbotReplyFaq = ({ children, title, ...rest }) => {
  return (
    <ActionLabelPill
      onClick={(event) => {
        event.preventDefault();

        publish(EVENT_CHATBOT_FAQ, {
          answer_id: rest['data-answer-id'],
          faqrequest: title,
          recognition_id: rest['data-recognition-id'],
          subQuery: { subtype: rest['data-subtype'] },
        });
      }}
    >
      <Text>{children}</Text>
    </ActionLabelPill>
  );
};
